import $ from "jquery";
import { formatMoney } from "../../tools/moneyFormats";
const $qtySelector = $("[data-qty]");
const $readMore = $(".product-read-more");
var is_first = true;
// Function to show ships_on metafield text
const showShipsOnText = function ($variantSelected) {
  const shipsOnText = $variantSelected.data("variant-oos");
  // Display ships_on text in a specific area
  if (shipsOnText) {
    $(".ships-on").show();
    $(".ships-on").text(shipsOnText); // Change the selector to match your specific area
  } else {
    $(".ships-on").hide().empty(); // Optional: Clear the text if there is no shipsOnText
  }
};
const updateProduct = function ($productForm) {
  if (!$productForm.length) return;
  const $variantSelected = $(
    "option:selected",
    $productForm.find("[data-all-variants]"),
  );
  $("[data-selected-variant-id]").val($variantSelected.val());
  if (typeof bwp !== "undefined")
    bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
  updatePrice($variantSelected, $productForm);
  updateOptions($variantSelected, $productForm);
  updateButton($variantSelected, $productForm);
  updateLowStock($variantSelected, $productForm);
  updateTopLabel($variantSelected, $productForm);
  updateImage($variantSelected, $productForm);
  updateHistoryState($variantSelected.val());
  // updateRecharge($variantSelected);
  showShipsOnText($variantSelected); // Display ships_on text
};

const updateProduct_first = function ($productForm) {
  if (!$productForm.length) return;
  const $variantSelected = $(
    "option:selected",
    $productForm.find("[data-all-variants]"),
  );
  $("[data-selected-variant-id]").val($variantSelected.val());

  if (typeof bwp !== "undefined")
    bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
  updatePrice($variantSelected, $productForm);
  updateOptions($variantSelected, $productForm);
  updateButton($variantSelected, $productForm);
  updateLowStock($variantSelected, $productForm);
  updateTopLabel($variantSelected, $productForm);
  updateImage_first($variantSelected, $productForm);
  updateHistoryState($variantSelected.val());
  // updateRecharge($variantSelected);
  showShipsOnText($variantSelected); // Display ships_on text
};

const updateProduct1 = function ($productForm) {
  if (!$productForm.length) return;
  const $variantSelected = $(
    "option:selected",
    $productForm.find("[data-all-variants]"),
  );
  $("[data-selected-variant-id1]").val($variantSelected.val());

  if (typeof bwp !== "undefined")
    bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
  updatePrice($variantSelected, $productForm);
  updateOptions($variantSelected, $productForm);
  updateButton($variantSelected, $productForm);
  updateLowStock($variantSelected, $productForm);
  updateTopLabel($variantSelected, $productForm);
  updateImage($variantSelected, $productForm);
  updateHistoryState($variantSelected.val());
  // updateRecharge($variantSelected);
};

const updateHistoryState = function (variant) {
  if (!history.replaceState || !variant) {
    return;
  }
  var newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?variant=" +
    variant;
  window.history.replaceState({ path: newurl }, "", newurl);
};

const updateImage = function ($variantSelected, $productForm) {
  if ($(".productTemplate--b").length != 0) {
    const option1 = $variantSelected.data("option1");
    const variantid = $variantSelected.val();
    if (typeof variantid != "undefined") {
      $(".product-images").attr("data--hidden", true).removeClass("active");
      $('.product-images[data-variant-color="' + option1 + '"]')
        .addClass("active")
        .removeAttr("data--hidden", true);
      $(".product-images.active [data-ps]").slick("refresh");
      $(".product-images.active  .mobile-product-images[data-ps]").slick(
        "refresh",
      );
      $("[data-ps]").slick("slickGoTo", 0);
    }
  }
};

const updateImage_first = function ($variantSelected, $productForm) {
  $(".product-slider").slick("slickGoTo", 0);
};

const updatePrice = function ($variantSelected, $productForm) {
  const $price =
    $productForm.find("[data-price]").length > 0
      ? $productForm.find("[data-price]")
      : $(".product-top-info [data-price]");
  const $priceCompare =
    $productForm.find("[data-price-compare]").length > 0
      ? $productForm.find("[data-price-compare]")
      : $(".product-top-info [data-price-compare]");
  const $benefit =
    $productForm.find("[data-price-save]").length > 0
      ? $productForm.find("[data-price-save]")
      : $(".product-top-info [data-price-save]");
  const price = $variantSelected.data("variant-price");
  const comparePrice = $variantSelected.data("variant-compare-price");
  let counter = 0;

  function checkParent(item) {
    return $(item).parents(".product-switcher__item").length > 0
      ? $(item).parents(".product-switcher__item").find("input").is(":checked")
      : true;
  }

  $price.each((index, item) => {
    if (checkParent(item)) {
      $(item).text(formatMoney(price));

      if ($priceCompare.length > 0 && checkParent($priceCompare[counter])) {
        comparePrice > 0
          ? $($priceCompare[counter]).text(formatMoney(comparePrice)).show()
          : $($priceCompare[counter]).hide();
        comparePrice > 0 && $benefit.length > 0
          ? $($benefit[counter])
              .text(
                "Save $" +
                  formatMoney(comparePrice - price, "{{amount_no_decimals}}"),
              )
              .show()
          : $($benefit[counter]).hide();
      }
      counter = ++counter;
    }
  });
};

const updateButton = function ($variantSelected, $productForm) {
  const stickyButton = $(".sticky-bottom--button [data-add-to-cart]");
  let $addToCart = $productForm.find("[data-add-to-cart]").add(stickyButton);

  var $preorder = $productForm.find(".preorder_text");
  var btn_label = window.theme.strings.addToCart;
  var is_preorder = $(".product-form").attr("data-preorder");
  var is_offer = $(".product-add-to-cart:not(.orginal-add-to-cart)").hasClass(
    "redeem-offer",
  );
  if (is_offer) {
    btn_label = window.theme.strings.redeemoffer;
  }

  if (!$productForm.hasClass("product-form--bundle")) {
    btn_label +=
      " - <span>" +
      formatMoney($variantSelected.attr("data-variant-price")) +
      "</span>";

    var btn_preorder_label =
      window.theme.strings.preOrder +
      " - <span>" +
      formatMoney($variantSelected.attr("data-variant-price")) +
      "</span>";

    if ($variantSelected.attr("data-variant-compare-price") != "") {
      btn_label +=
        '<span class="was"> (' +
        formatMoney($variantSelected.attr("data-variant-compare-price")) +
        ")</span>";
    }
  }

  var interval = 1;

  if (is_first) {
    interval = 1000;
  }

  if ($variantSelected.data("subscription-id") != "") {
    let text = window.theme.strings.recharge;
    if (
      $variantSelected.data("product-handle") &&
      $variantSelected.data("product-handle").indexOf("annual") != -1
    ) {
      let price = formatMoney($variantSelected.data("variant-price"));
      text += " - " + price;
    }
    $addToCart.attr("disabled", false).text(text);
    $(".custom-bis-trigger").removeClass("visible");
  } else if ($variantSelected.data("available") == true) {
    if (
      is_preorder == "true" &&
      $variantSelected.data("inventory-quantity") <= 0
    ) {
      if (
        $variantSelected.closest(".product-form").find(".product-progress")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-progress")
          .removeClass("hide");
      }
      if (
        $variantSelected.closest(".product-form").find(".product-preorder")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-preorder")
          .removeClass("hide");
      }
      $(".preorder_text").removeClass("hide");
    } else {
      if (
        $variantSelected.closest(".product-form").find(".product-progress")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-progress")
          .addClass("hide");
      }
      if (
        $variantSelected.closest(".product-form").find(".product-preorder")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-preorder")
          .addClass("hide");
      }
      $(".preorder_text").addClass("hide");
    }

    if (
      $variantSelected.data("inventory-policy") == "continue" &&
      $variantSelected.data("inventory-quantity") <= 0 &&
      $variantSelected.data("product-handle") != "beast-e-gift-card"
    ) {
      $addToCart.attr("disabled", false).html(btn_preorder_label);
      $preorder.removeAttr("data--hidden");
    } else {
      $addToCart.attr("disabled", false).html(btn_label);
    }
    $(".custom-bis-trigger").removeClass("visible");
  } else {
    if (
      is_preorder == "true" &&
      $variantSelected.data("inventory-quantity") <= 0
    ) {
      $addToCart.attr("disabled", false).html(btn_preorder_label);
      $preorder.removeAttr("data--hidden");
      $(".custom-bis-trigger").removeClass("visible");
      if (
        $variantSelected.closest(".product-form").find(".product-progress")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-progress")
          .removeClass("hide");
      }
      if (
        $variantSelected.closest(".product-form").find(".product-preorder")
          .length > 0
      ) {
        $variantSelected
          .closest(".product-form")
          .find(".product-preorder")
          .removeClass("hide");
      }
      $(".preorder_text").removeClass("hide");
    } else {
      if (!$productForm.hasClass("product-form--bundle")) {
        $addToCart
          .attr("disabled", true)
          .text(
            window.theme.strings.soldOut +
              " - " +
              formatMoney($variantSelected.data("variant-price")),
          );
      } else {
        $addToCart.attr("disabled", true).text(window.theme.strings.soldOut);
      }

      $preorder.attr("data--hidden", "true");
      setTimeout(function () {
        $(".custom-bis-trigger").addClass("visible");
      }, interval);
    }
  }
  is_first = false;
};

const updateTopLabel = function ($variantSelected, $productForm) {
  const $topLabel = $productForm.find(".product-info__top-label").find("span");
  if (
    $variantSelected.data("product-handle") &&
    $variantSelected.data("product-handle").indexOf("annual") != -1 &&
    $variantSelected.data("subscription-id") != "" &&
    $topLabel.length
  ) {
    let text = window.theme.strings.recharge;
    let price = formatMoney($variantSelected.data("variant-price"));
    text += " - " + price;
    text = $(`<b>${text}</b>`);
    $topLabel.html(text);
  }
};

const updateLowStock = function ($variantSelected, $productForm) {
  const $lowStock = $productForm.find("[data-low-stock]");
  if ($variantSelected.data("available")) {
    $lowStock.removeClass("hide");
  } else {
    $lowStock.addClass("hide");
  }
};

const syncBundleRadioStates = function ($variantSelected, $productForm) {
  const option1 = $variantSelected.data("option1");
  const option2 = $variantSelected.data("option2");
  const option3 = $variantSelected.data("option3");
  if (option2 && option2 !== "_BLANK_") {
    $productForm.find("[data-product-option=2]").prop("checked", false).parent().find("label").removeClass("checked");
    const $r2 = $productForm.find(`[data-product-option=2][value="${option2}"]`);
    $r2.prop("checked", true).parent().find("label").addClass("checked");
  }
  if (option3 && option3 !== "_BLANK_") {
    $productForm.find("[data-product-option=3]").prop("checked", false).parent().find("label").removeClass("checked");
    const $r3 = $productForm.find(`[data-product-option=3][value="${option3}"]`);
    $r3.prop("checked", true).parent().find("label").addClass("checked");
  }
  if (option1 && option1 !== "_BLANK_") {
    const $r1 = $productForm.find(`[data-product-option=1][value="${option1}"]`);
    $r1.prop("checked", true).parent().find("label").addClass("checked");
  }
};

const updateOptions = function ($variantSelected, $productForm) {
  // For bundle products the variant list is capped at 250 — do not disable swatches
  // based on an incomplete availability picture. Still sync radio checked states.
  if ($productForm.hasClass("product-form--bundle")) {
    syncBundleRadioStates($variantSelected, $productForm);
    return;
  }

  // Update option 1
  $("[data-product-option=1]").each(function (index, option1) {
    const $productForm = $(this).closest("[data-product-form]");
    let disabled = true;
    const optionVal = $(option1).val();
    $productForm
      .find("[data-all-variants]")
      .find("option")
      .each(function (index, selectOption) {
        if (
          $(selectOption).data("option1") == optionVal &&
          $(selectOption).data("available") == true
        ) {
          disabled = false;
        }
      });
    if (disabled) {
      // $(option1).attr('disabled', true);
      $(option1).addClass("is-disabled");
    }
  });

  // Update options 2 and 3
  const option1 = $variantSelected.data("option1");
  $productForm
    .find("[data-all-variants]")
    .find("option")
    .each(function (index, selectOption) {
      if ($(selectOption).data("option1") == option1) {
        const option2 = $(selectOption).data("option2");
        const $option2 = $(`[data-product-option=2][value='${option2}']`);
        const option3 = $(selectOption).data("option3");
        const $option3 = $(`[data-product-option=3][value='${option3}']`);
        if ($(selectOption).data("available") == false) {
          $(option2).addClass("is-disabled");
          $(option3).addClass("is-disabled");
        } else {
          $option2.attr("disabled", false);
          $option3.attr("disabled", false);
        }
      }
    });
};

const fetchVariantFromSection = async ($productForm, option1, option2, option3) => {
  const productHandle = $productForm.data('product-handle');
  const sectionId = $productForm.data('section-id');
  if (!productHandle || !sectionId) return null;

  const getValueId = (optionNum, value) => {
    if (value === '_BLANK_') return null;
    return $productForm.find(`[data-product-option=${optionNum}][value='${value}']`).data('option-value-id') || null;
  };

  const ids = [getValueId(1, option1), getValueId(2, option2), getValueId(3, option3)].filter(Boolean);
  if (!ids.length) return null;

  const url = `/products/${productHandle}?option_values=${ids.join(',')}&section_id=${sectionId}`;
  try {
    const response = await fetch(url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newForm = doc.querySelector('[data-product-form]');
    if (!newForm) return null;

    const newVariantId = newForm.dataset.variantid;
    if (!newVariantId) return null;

    const newPriceEl = doc.querySelector('[data-price]');
    const newComparePriceEl = doc.querySelector('[data-price-compare]');
    const newBtn = doc.querySelector('[data-add-to-cart]');

    $('[data-selected-variant-id]').val(newVariantId);
    $productForm.attr('data-variantid', newVariantId);
    updateHistoryState(newVariantId);

    if (newPriceEl) {
      $productForm.find('[data-price]').text(newPriceEl.textContent.trim());
      $('.product-top-info [data-price]').text(newPriceEl.textContent.trim());
    }
    if (newComparePriceEl) {
      const compareText = newComparePriceEl.textContent.trim();
      if (compareText) {
        $productForm.find('[data-price-compare]').text(compareText).show();
        $('.product-top-info [data-price-compare]').text(compareText).show();
      } else {
        $productForm.find('[data-price-compare]').hide();
        $('.product-top-info [data-price-compare]').hide();
      }
    }
    if (newBtn) {
      const isDisabled = newBtn.hasAttribute('disabled');
      const $atcBtn = $productForm.find('[data-add-to-cart]');
      if (isDisabled) {
        $atcBtn.attr('disabled', true).text(window.theme.strings.soldOut);
        setTimeout(() => { $('.custom-bis-trigger').addClass('visible'); }, 1000);
      } else {
        $atcBtn.attr('disabled', false).html(newBtn.innerHTML);
        $('.custom-bis-trigger').removeClass('visible');
      }
    }
    return newVariantId;
  } catch (e) {
    console.error('Variant fetch failed', e);
    return null;
  }
};

export default function () {
  // Sync option label spans with the initially-checked radio values
  const $opt1Checked = $("[data-product-option=1]:checked");
  const $opt2Checked = $("[data-product-option=2]:checked");
  const $opt3Checked = $("[data-product-option=3]:checked");
  if ($opt1Checked.length) $("#product_option1").text($opt1Checked.val());
  if ($opt2Checked.length) $("#product_option2").text($opt2Checked.val());
  if ($opt3Checked.length) $("#product_option3").text($opt3Checked.val());

  // Variants changing (automatically triggers from options changing)
  $(document).on("change", "[data-all-variants]", function () {
    updateProduct($(this).closest("[data-product-form]"));
  });

  $qtySelector.on("change", function () {
    updateProduct($(this).closest("[data-product-form]"));
  });

  $readMore.on("click", function () {
    $(this).parent().parent().find(".product-block").removeClass("read-more");
    $(this).parent().addClass("read-more");
  });

  $(document).on("click", "[data-in-box]", function () {
    if ($(this).data("in-box") == true) {
      $(".in-box-arrow").show();

      var ls_index = 100;
      $("[data-ps] .slick-slide:not(.slick-cloned)").each(function (index) {
        if ($(this).find("[data-box-image]").length > 0) {
          ls_index = index;
        }
      });

      try {
        const slideIndex = ls_index;

        if (slideIndex < 100) {
          $(".product-slider").slick("slickGoTo", slideIndex);
        }
      } catch {
        console.log("No in box image");
      }
    } else {
      $(".in-box-arrow").hide();
    }
  });

  // Options changing
  $(document).on("click", "[data-product-option]", function () {
    const $productForm = $(this).closest("[data-product-form]");

    const option1 = $productForm.find("[data-product-option=1]:checked").val() || "_BLANK_";
    const option2 = $productForm.find("[data-product-option=2]:checked").val() || "_BLANK_";
    const option3 = $productForm.find("[data-product-option=3]:checked").val() || "_BLANK_";
    const $vSelector = $productForm.find("[data-all-variants]");
    const value = $vSelector
      .find(
        `[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
      )
      .val();

    if (value !== undefined) {
      $vSelector.val(value).trigger("change");
    } else {
      // Variant not in the first 250 — use Section Rendering API
      fetchVariantFromSection($productForm, option1, option2, option3);
      updateImage($vSelector.find("option:selected"), $productForm);
    }

    // Update option label spans (scoped to this form)
    if (option1 !== "_BLANK_") $productForm.find("#product_option1").text(option1);
    if (option2 !== "_BLANK_") $productForm.find("#product_option2").text(option2);
    if (option3 !== "_BLANK_") $productForm.find("#product_option3").text(option3);

    $productForm.find(".product-option__color").removeClass("checked");
    $(this).parent().find("label").addClass("checked");
  });

  // Options changing
  $("#option-size1").on("change", function () {
    const $productForm = $(this).closest("[data-product-form]");
    const option1 = $productForm.find("#option-size1").val()
      ? $productForm.find("#option-size1").val()
      : "_BLANK_";
    const option2 = $productForm.find("[data-product-option=2]:checked").length
      ? $productForm.find("[data-product-option=2]:checked").val()
      : "_BLANK_";
    const option3 = $productForm.find("[data-product-option=3]:checked").length
      ? $productForm.find("[data-product-option=3]:checked").val()
      : "_BLANK_";
    const $vSelector = $productForm.find("[data-all-variants]");
    const value = $vSelector
      .find(
        `[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
      )
      .val();
    $vSelector.val(value).trigger("change");

    //Option name changing
    $("#product_option1").text($("#option-size1").val());
  });

  var _flag = false;
  $("[data-custom-dropdown] .selected_val").on("mouseover", function () {
    _flag = true;
  });

  $("[data-custom-dropdown] .selected_val").on("mouseleave", function () {
    _flag = false;
  });

  $(document).on("click", function () {
    if (_flag == false) {
      $("[data-custom-dropdown] .selected_val").removeClass("active");
      $("[data-custom-dropdown] .dropdown-list").removeClass("visible");
    }
  });

  $(document).on("click", ".custom-bis-trigger button", function (e) {
    e.preventDefault();
    $(".klaviyo-bis-trigger")[0].click();
  });

  $("[data-custom-dropdown] .dropdown-list span").on("click", function () {
    $("#option-size2").val($(this).text()).change();
  });

  $("[data-custom-dropdown] .selected_val").on("click", function () {
    $(this).toggleClass("active");
    $(this).next(".dropdown-list").toggleClass("visible");
  });

  // Options changing
  $("#option-size2").on("change", function () {
    const $productForm = $(this).closest("[data-product-form]");
    const option1 = $productForm.find("[data-product-option=1]:checked").length
      ? $productForm.find("[data-product-option=1]:checked").val()
      : "_BLANK_";
    const option2 = $productForm.find("#option-size2").val()
      ? $productForm.find("#option-size2").val()
      : "_BLANK_";
    const option3 = $productForm.find("[data-product-option=3]:checked").length
      ? $productForm.find("[data-product-option=3]:checked").val()
      : "_BLANK_";
    const $vSelector = $productForm.find("[data-all-variants]");
    const value = $vSelector
      .find(
        `[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
      )
      .val();
    // $vSelector.val(value).trigger('change');
    console.log("variantselector value", $vSelector.val());
    //Option name changing
    $("#product_option2").text($("#option-size2").val());

    var targetObj = $("[data-redirect-selector]").find(
      'option[data-value1="' + option1 + '"][data-value2="' + option2 + '"]',
    );

    window.location.href = "/products/" + targetObj.attr("data-url");
  });

  // Options changing
  $("#option-size3").on("change", function () {
    const $productForm = $(this).closest("[data-product-form]");
    const option1 = $("[data-product-option=1]:checked").length
      ? $("[data-product-option=1]:checked").val()
      : "_BLANK_";
    const option2 = $("[data-product-option=2]:checked").length
      ? $("[data-product-option=2]:checked").val()
      : "_BLANK_";
    const option3 = $("#option-size3").val()
      ? $("#option-size3").val()
      : "_BLANK_";
    const $vSelector = $productForm.find("[data-all-variants]");
    const value = $vSelector
      .find(
        `[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
      )
      .val();
    $vSelector.val(value).trigger("change");
    console.log("variantselector value", $vSelector.val());
    //Option name changing
    $("#product_option3").text($("#option-size3").val());
  });

  if (window.productTemplateLoaded) {
    updateProduct_first($(".product-main").find("[data-product-form]"));
    updateProduct1($(".product-main").find("[data-product-form1]"));
  }

  $(document).on("click", ".product-preorder-title.hide--desktop", function () {
    if ($(this).closest(".product-preorder-items").hasClass("open")) {
      $(this).closest(".product-preorder-items").removeClass("open");
      $(this)
        .closest(".product-preorder-items")
        .find(".product-preorder-subtitle")
        .addClass("hide--mobile");
      $(this)
        .closest(".product-preorder-items")
        .find(".product-preorder-item")
        .addClass("hide--mobile");
    } else {
      $(this).closest(".product-preorder-items").addClass("open");
      $(this)
        .closest(".product-preorder-items")
        .find(".product-preorder-subtitle")
        .removeClass("hide--mobile");
      $(this)
        .closest(".product-preorder-items")
        .find(".product-preorder-item")
        .removeClass("hide--mobile");
    }
  });
}
